<div class="px-2 py-1 bg-red-50 border-round-2xl">
  <i class="fa fa-exclamation-circle text-red-500" style="margin-right: 5px"></i>
  <ng-content></ng-content>
</div>
